import { wrappedFetch } from "../../checkout/helpers/fetch";
import { setJsLocale, setDefaultJsLocale, setServerLocale, setDefaultServerLocale, setLanguages } from "../../checkout/actions/intl";
import { setListingId, setHideBestAvailable, setBestAvailableButtonText, setDisableBestAvailable } from "../../checkout/actions/ui";
import { setFetchedEventId, setEventData, setListingInfoData } from '../../checkout/actions/event';
import { setMaintenanceMode, setDefaultShowCalendarInModal, setShowCalendarInModal, setCheckoutConfig, setListingConfig, resetUi } from '../../checkout/actions/ui';
import { setShouldFetchUpsells } from '../../checkout/views/upsells/actions/upsells';
import { setEmailOptOut, setDefaultEmailOptOut } from '../../checkout/views/member/actions/member';
import { setWidth } from '../../checkout/views/series/actions/event-series';
import { EMBED_TYPE_CALENDAR, EMBED_TYPE_MULTI } from '../../checkout/reducers/ui';

export function sendSlackMessage(message, type) {
    return (dispatch, getState) => {
        const state = getState();
        const req = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({message, type, user: state.reservation.purchaseUser}),
        };

        wrappedFetch(state.ui.apiUrl + '/kiosks/send-notification', req).then((res) => {});
    }
}

export const loadListingDataIntoState = (
    listingId,
    eventId,
    embedType,
    listingInfo,
    listingConfig,
    dynamicListing,
    maintenanceMode,
    languageParams,
) => {
    return dispatch => {
        dispatch(resetUi());
        dispatch(setListingId(listingId));
        dispatch(setListingInfoData(listingInfo));

        let shouldFetchUpsells = !!listingConfig?.shouldFetchUpsells;

        if (Object.keys(listingInfo?.event || [])?.length !== 0) {
            const newEvent = {...listingInfo.event};
            dispatch(setEventData(newEvent));

            const reservedSeating = newEvent?.attributes?.events?.[eventId]?.reserved_seating;

            dispatch(setHideBestAvailable(!!reservedSeating?.hideBestAvailable));
            dispatch(setDisableBestAvailable(!!reservedSeating?.disableBestAvailable));
            dispatch(setBestAvailableButtonText(reservedSeating?.bestAvailableButtonText));

            if (newEvent.attributes?.shouldFetchUpsells) {
                shouldFetchUpsells = true;
            }
        }

        if (dynamicListing) {
            shouldFetchUpsells = false;
        }

        dispatch(setShouldFetchUpsells(shouldFetchUpsells));
        dispatch(setMaintenanceMode(maintenanceMode));
        dispatch(setFetchedEventId(embedType === EMBED_TYPE_MULTI ? eventId : undefined));

        // load in language params
        if (languageParams) {
          dispatch(setJsLocale(languageParams?.jsLocale ?? 'en-US'));
          dispatch(setDefaultJsLocale(languageParams?.jsLocale ?? 'en-US'));
          dispatch(setLanguages(languageParams?.languages ?? []));
          dispatch(setServerLocale(languageParams?.locale ?? 'en_US', languageParams?.translations ?? {}));
          dispatch(setDefaultServerLocale(languageParams?.locale ?? 'en_US'));
        }

        if (window && window.innerWidth) {
            dispatch(setWidth(window.innerWidth));
        }

        if(listingConfig.checkout) {
            dispatch(setCheckoutConfig(listingConfig.checkout));
            if (
                embedType == EMBED_TYPE_CALENDAR ||
                (listingConfig.checkout.seriesOptions && listingConfig.checkout.seriesOptions.calendarOnListing)
            ) {
                dispatch(setDefaultShowCalendarInModal(false));
                dispatch(setShowCalendarInModal(false));
            }
        }

        if(listingConfig && Object.keys(listingConfig).length > 0) {
            dispatch(setListingConfig(listingConfig));
            dispatch(setDefaultEmailOptOut(listingConfig.opt_out_by_default));
            dispatch(setEmailOptOut(listingConfig.opt_out_by_default));
        }
    }
}
